import React from "react";
import { Grid } from "@mui/material";

const HalfColumn = ({ children }) => (
  <Grid size={{ xs: 6, md: 3 }}>
    {children}
  </Grid>
);

export default HalfColumn;
